<template>
    <div id="head">
        <div class="user-box" v-if="! userInfo && association && association.cansignup">
            <button class="btn-login" @click="showRegister=false;showLogin=true">登录</button>
            <!-- <span class="divider"></span> -->
            <!-- <button class="btn-register" @click="showLogin=false;showRegister=true">注册</button> -->
        </div>
        <a-dropdown v-if="userInfo" class="user-info">
            <a-menu slot="overlay" @click="handleMenuClick">
                <a-menu-item key="0">個人中心</a-menu-item>
                <a-menu-item key="1">退出登錄</a-menu-item>
            </a-menu>
            <router-link class="userinfo" to="/user/myActivity">
                <a-icon type="user" />
                <span v-text="userInfo.clientname || userInfo.clientno"></span>
            </router-link>
        </a-dropdown>
        <div class="head-container">
            <a href="/" class="logo">
                <img v-if="association" :src="association.logourl" alt="">
            </a>
            <ul :class="{'menus': true, 'show': showMenus}">
                <li :class="{'menu': true, 'current': menuIndex==1}" @click="showMenus=false"><router-link to="/">首 頁</router-link></li>
                <li :class="{'menu': true, 'current': menuIndex==2, 'more': true, 'checked': checkedIndex==2}" @click.stop="onMenuClick(2)">關於我們
                    <ul :class="{'more-items': true, 'show': checkedIndex}">
                        <li v-if="association.introduce" :class="{'more-item': true, 'current': moreIndex == 1}" @click="showMenus=false">
                            <router-link to="/AboutUs#section0" v-text="association.introduce1"></router-link>
                        </li>
                        <li v-if="association.concept" :class="{'more-item': true, 'current': moreIndex == 2}" @click="showMenus=false">
                            <router-link to="/AboutUs#section1" v-text="association.concept1"></router-link>
                        </li>
                        <li v-if="association.regulation" :class="{'more-item': true, 'current': moreIndex == 3}" @click="showMenus=false">
                            <router-link to="/AboutUs#section2" v-text="association.regulation1"></router-link>
                        </li>
                        <li :class="{'more-item': true, 'current': moreIndex == 4}" @click="showMenus=false">
                            <router-link to="/Organization">架構及成員</router-link>
                        </li>
                    </ul>
                </li>
                <li :class="{'menu': true, 'current': menuIndex==3}" @click="showMenus=false"><router-link to="/ActivityList">課程及活動</router-link></li>
                <li :class="{'menu': true, 'current': menuIndex==4}" @click="showMenus=false"><router-link to="/ActivityPhotos/list">活動照片</router-link></li>
                <li :class="{'menu': true, 'current': menuIndex==5}" @click="showMenus=false"><router-link to="/LiteratureList">學術及文化</router-link></li>
                <li :class="{'menu': true, 'current': menuIndex==6}" @click="showMenus=false"><router-link to="/JoinUs">加入學會</router-link></li>
                <li :class="{'menu': true, 'mobile': true, 'current': menuIndex==7}" v-if="userInfo"><router-link to="/user/myActivity">個人中心</router-link></li>
                <li :class="{'menu': true, 'mobile': true}" @click="logout" v-if="userInfo">退出登錄</li>
                <li :class="{'menu': true, 'mobile': true}"  v-if="!userInfo && association && association.cansignup">
                    <a class="btn-login" id="login" href="javascript:;" @click="showLogin=true;showMenus=false">登錄</a>
                    <!-- <a class="btn-register" href="javascript:;" @click="showLogin=true;showMenus=false">註冊</a> -->
                </li>
            </ul>
            <span class="btn-menu" @click.stop="onMobileMenuClick">
                <a-icon type="menu" class="icon"/>
            </span>
        </div>
        <login v-if="showLogin" :callback="onLoginClose"/>
        <register v-if="showRegister" :callback="onRegisterClose"/>
        <forget-pwd v-if="showForgetPwd" :callback="onForgetPwdClose"/>
        <a-modal
            title="公告"
            style="z-index: 10001"
            width="85%"
            :visible="noticeVisible"
            :maskClosable="false"
            @cancel="noticeVisible = false"
            :footer="null">
            <div class="dialog-content">
                <div v-html="notice"></div>
            </div>
        </a-modal>
        <a-modal
            style="z-index: 10003"
            width="800px"
            wrapClassName="declaration-modal"
            :dialog-style="{transition: 'all 1s linear', top: '50%', transform: 'translateY(-50%)' }"
            :bodyStyle="{'min-height': '77vh', 'max-height': '95vh'}"
            :closable="false"
            :visible="showDeclaration"
            :maskClosable="false"
            :footer="null">
            <div class="declaration-content">
                <h3 class="title">網站聲明</h3>
                <a :href="providerUrl" target="_blank" class="logo-declaration"><img src="../assets/imgs/ic_logo_declaration.png"></a>
                <div v-html="association.explain" class="desc"></div>
                <a-checkbox @change="onDeclarationBtnChange" v-model="declarationBtnEnable" class="cb-agree">我已知曉</a-checkbox>
                <div @click="onDeclarationBtnClick" class="btn-agree">繼續訪問學會網站</div>
            </div>
        </a-modal>
    </div>
</template>

<script>
import Login from '../components/user/Login'
import ForgetPwd from './user/ForgetPwd.vue'
import Register from './user/Register.vue'
import * as types from '@/store/mutation-types.js'
export default {
    components: {
        Login,
        Register,
        ForgetPwd,
    },
    props: {
        flag: null,
    },
    data(){
        return {
            providerUrl: "https://www.ectcm.com",
            loginData: null,
            showMenus: false,
            association: this.$store.getters.association,
            menuIndex: -1,
            checkedIndex: 0,
            moreIndex: 0,
            showLogin: false,
            showRegister: false,
            showForgetPwd: false,
            userInfo: this.$store.getters.userInfo,
            notice: '',
            noticeVisible: false,
            showDeclaration: false, //显示网站声明
            declarationBtnEnable: false,
        }
    },
    mounted: function(){
        try {
            let _notice = this.association && this.association.notice
            if(_notice) {
                let _fromTime = new Date((this.association.noticefrom || '1979-01-01')).getTime()
                let _toTime = new Date((this.association.noticeto || '1979-01-01')).getTime()
                let _now = Date.now()
                if(_now >= _fromTime && _now <= _toTime ) {
                    this.noticeVisible = true
                    this.notice = _notice
                }
            }
        } catch (e) {
        }
        var to = this.$route
        if(to.path == '/') {
            this.menuIndex = 1
        } else if(to.path.startsWith('/home')) {
            this.menuIndex = 1
        } else if(to.path == '') {
            this.menuIndex = 1
        }  else if(to.path == '/ActivityList') {
            this.menuIndex = 3
        } else if(to.path.startsWith('/ActivityDetail/')){
            this.menuIndex = 3
        } else if(to.path == '/AboutUs') {
            this.menuIndex = 2
        } else if(to.path == '/Organization') {
            this.menuIndex = 2
        } else if(to.path.startsWith('/ActivityPhotos/list')) {
            this.menuIndex = 4
        } else if(to.path == '/ActivityPhotos') {
            this.menuIndex = 4
        } else if(to.path.startsWith('/ActivityPhotos/details/')) {
            this.menuIndex = 4
        } else if(to.path.startsWith('/LiteratureList')) {
            this.menuIndex = 5
        } else if(to.path.startsWith('/LiteratureDetail')) {
            this.menuIndex = 5
        } else if(to.path == '/JoinUs') {
            this.menuIndex = 6
        } else if(to.path == '/user') {
            this.menuIndex = 7
        }

        this.moreIndex = 0
        if(location.href.endsWith('/AboutUs#section0')) {
            this.moreIndex = 1
        } else if(location.href.endsWith('/AboutUs#section1')) {
            this.moreIndex = 2
        } else if(location.href.endsWith('/AboutUs#section2')) {
            this.moreIndex = 3
        } else if(location.href.endsWith('/Organization')) {
            this.moreIndex = 4
        }
    },
    created(){
        if(process.env.VUE_APP_API.indexOf('preapi') != -1) {
            this.providerUrl = 'https://preview.ectcm.com'
        }
    },
    methods: {
        logout: function(){
            this.$store.dispatch('logout', {
                clientId: this.userInfo.clientid,
                token: this.$store.getters.token,
            })
            this.userInfo = null
            window.location.href="/"
        },
        onMobileMenuClick: function(){
            this.showMenus = ! this.showMenus
        },
        handleMenuClick: function(e) {
            const that = this
            switch(e.key) {
                case '1':
                    //退出登錄
                    this.$confirm({
                        title: '確認退出登錄?',
                        okText: "確認",
                        cancelText: "取消",
                        onOk(){
                            that.$store.dispatch('logout', {
                                clientId: that.userInfo.clientid,
                                token: that.$store.getters.token,
                            })
                            that.userInfo = null
                            window.location.href="/"
                        },
                        onCancel(){
                        }
                   })
                    break;
                case '0':
                    //个人中心
                    this.$router.push('/user/myActivity')
                 break;
            }
        },
        onMenuClick: function(index){
            this.checkedIndex = (index == this.checkedIndex) ? 0 : index
        },
        onLoginClose: function(v, data){
            this.showLogin = false
            if(v === 'register') {
                this.showRegister = true
            } else if(v === 'forgetPwd') {
                this.showForgetPwd = true
            } else if(v === 'loginSuccess') {
                this.loginData = data
                this.userInfo = this.loginData.userInfo
                try {
                    this.loginData.commit(types.SET_TOKEN, this.loginData.token)
                    this.loginData.commit(types.SET_USER_INFO, JSON.stringify(this.userInfo))
                } catch (error) {
                }
                this.$message.success('登錄成功')
                if(this.$route.path.startsWith('/ActivityDetail/')) {
                    window.location.reload();
                }
                
                ///登录成功显示同意协议
                // this.loginData = data
                // if(this.loginData.userInfo.checkedSiteDesc == 1) {
                //     this.userInfo = this.loginData.userInfo
                //     try {
                //         this.loginData.commit(types.SET_TOKEN, this.loginData.token)
                //         this.loginData.commit(types.SET_USER_INFO, JSON.stringify(this.userInfo))
                //     } catch (error) {
                //     }
                //     this.$message.success('登錄成功')
                //     if(this.$route.path.startsWith('/ActivityDetail/')) {
                //         window.location.reload();
                //     }
                // } else {
                //    this.showDeclaration = true 
                // }
            }
        },
        onRegisterClose: function(v){
            this.showRegister = false
            if(v === 'login') {
               this.showLogin = true 
            } else if(v === 'registerSuccess') {
                this.showLogin = true
            }
        },
        onForgetPwdClose: function(v){
            this.showForgetPwd = false
            if(v === 'login') {
               this.showLogin = true 
            }
        },
        onDeclarationBtnChange: function(e){
            this.declarationBtnEnable = e.target.checked
        },
        onDeclarationBtnClick: function(e) {
            if(!this.declarationBtnEnable) {
                this.$message.warning('未勾選已知曉')
                return
            }
            if(this.declarationBtnEnable) {
                //隱藏窗口
                this.showDeclaration = false
                this.declarationBtnEnable = false
                if(this.loginData) {
                    this.userInfo = this.loginData.userInfo
                    this.$store.dispatch('checkedProtocol', {
                        clientId: this.userInfo.clientid,
                        checked: 1
                    })
                    try {
                        this.loginData.commit(types.SET_TOKEN, this.loginData.token)
                        this.loginData.commit(types.SET_USER_INFO, JSON.stringify(this.userInfo))
                    } catch (error) {
                    }
                    this.$message.success('登錄成功')
                    if(this.$route.path.startsWith('/ActivityDetail/')) {
                        window.location.reload();
                    }
                }
            }
        }
    },
    watch: {
        '$props.flag': function(v) {
            if(this.checkedIndex) {
                this.onMenuClick(2)
            }
            this.showMenus = false
        },
        $route: function(to, from) {
            this.menuIndex = 0
            if(to.path == '/') {
                this.menuIndex = 1
            } else if(to.path.startsWith('/home')) {
                this.menuIndex = 1
            } else if(to.path == '') {
                this.menuIndex = 1
            } else if(to.path == '/ActivityList') {
                this.menuIndex = 3
            } else if(to.path.startsWith('/ActivityDetail/')){
                this.menuIndex = 3
            } else if(to.path == '/AboutUs') {
                this.menuIndex = 2
            } else if(to.path == '/Organization') {
                this.menuIndex = 2
            } else if(to.path.startsWith('/ActivityPhotos/list')) {
                this.menuIndex = 4
            } else if(to.path == '/ActivityPhotos') {
                this.menuIndex = 4
            } else if(to.path.startsWith('/ActivityPhotos/details/')) {
                this.menuIndex = 4
            } else if(to.path.startsWith('/LiteratureList')) {
                this.menuIndex = 5
            } else if(to.path.startsWith('/LiteratureDetail')) {
                this.menuIndex = 5
            } else if(to.path == '/JoinUs') {
                this.menuIndex = 6
            } else if(to.path == '/user') {
                this.menuIndex = 7
            }

            this.moreIndex = 0
            if(location.href.endsWith('/AboutUs#section0')) {
                this.moreIndex = 1
            } else if(location.href.endsWith('/AboutUs#section1')) {
                this.moreIndex = 2
            } else if(location.href.endsWith('/AboutUs#section2')) {
                this.moreIndex = 3
            } else if(location.href.endsWith('/Organization')) {
                this.moreIndex = 4
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#head {
    position: fixed;
    z-index: 100;
    width: 100%;
    height: 80px;
    background-color: #fefefe;
    padding: 8px;
    box-shadow: 2px 2px 5px #e8e8e8;
}
 
#head .user-box {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 80px;
}

#head .userinfo {
   position: absolute;
    right: 30px;
    top: 50%;
    z-index: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: #f5222d;
    transform: translateY(-50%);
}

#head .user-box .btn-login {
    height: 33px;
    line-height: 33px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #5bc0de;
    padding: 0 12px;
    border-radius: 4px;
    margin-right: 24px;
}

#head .user-box .btn-register {
    height: 33px;
    line-height: 33px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #eb9316;
    padding: 0 12px;
    border-radius: 4px;
    margin-right: 24px;
}

#head .user-box .login:active,
#head .user-box .register:active {
    opacity: 0.7;
}

#head .user-box .divider {
    height: 24px;
    width: 1px;
    background-color: #d8d8d8;
    margin: 0px 24px;
}

#head .head-container {
    max-width: 900px;
    margin-right: 185px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    box-sizing: border-box;
    position: relative;
    background-color: #fefefe;
    z-index: 2;
}

#head .logo {
    height: 64px;
    width: 240px;
}

#head .logo > img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

#head .menus {
    display: flex;
    flex-direction: row;
    flex: 1;
    align-items: center;
    height: 100%;
    margin-left: 20px;
    justify-content: space-around;
}

#head .menus > .menu {
    font-size: 18px;
    font-weight: bold;
    color: #232323;
    cursor: pointer;
    height: 64px;
    line-height: 64px;
    user-select: none;
}

#head .menus > .menu.mobile {
    display: none;
}

#head .menus > .menu.current {
    color: #f00;
}

#head .menus > .menu.more {
    position: relative;
    padding: 0 36px 0 12px;
}

#head .menus > .menu.checked {
    background-color: #bfbfbf4d;
}

#head .menus > .menu.more::after {
    position: absolute;
    right: 6px;
    top: 50%;
    content: '';
    width: 24px;
    height: 24px;
    background-image: url(../assets/imgs/ic_arrow_down.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transform: translateY(-50%);
}

#head .menus .more-items {
    position: absolute;
    left: 0;
    top: 64px;
    width: 120px;
    display: none;
    flex-direction: column;
    background-color: #fff;
    box-shadow: 2px 2px 5px #ebebeb, -2px -2px 5px #ebebeb;
    padding: 2px;
}

#head .menus .more-items.show {
    display: flex;
}

#head .menus .more-items > .more-item {
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    padding: 0 12px;
    font-size: 18px;
    font-weight: bold;
    color: #232323;
}

#head .menus .more-items > .more-item.current {
    color: #f00;
}

#head .menus .more-items > .more-item:hover {
    background-color: #bfbfbf4d;
}

#head .head-container .btn-menu {
    display: none;
}

.dialog-content {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 180px);
    overflow-y: scroll;
}

@media only screen and (max-width: 1050px) {
    #head .menus {
        position: absolute;
        left: unset;
        right: -2px;
        top: 80px;
        background-color: #fff;
        z-index: 999;
        margin: unset;
        padding: unset;
        flex-direction: column;
        height: unset;
        width: 140px;
        display: none;
        border: 1px solid #e8e8e8;
        box-shadow: 2px 2px 5px #e8e8e8, -2px 2px 5px #e8e8e8;
    }

    #head .menus.show {
        display: flex;
    }

    #head .head-container {
        max-width: unset;
        margin-right: unset;
        width: 100%;
        justify-content: space-between;
        align-items: center;
    }

    #head .head-container .btn-menu {
        width: 33px;
        height: 33px;
        border: 1px solid #c7c7c7;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        cursor: pointer;
        border-radius: 2px;
    }

    #head .head-container .btn-menu > .icon {
        color: #c7c7c7;
    }

    #head .head-container .btn-menu:active {
        opacity: 0.7;
    }

    #head .menus .more-items {
        top: 41px;
    }

    #head .menus > .menu {
        height: 40px;
        line-height: 40px;
        border-bottom: 1px solid #eee8e8;
        width: 100%;
        text-align: center;
    }
    
    #head .menus > .menu.mobile {
        display: block;
    }

    #head .user-info,
    #head .user-box {
        display: none;    
    }

    #head .btn-login {
        height: 33px;
        line-height: 33px;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        background-color: #5bc0de;
        padding: 0 12px;
        border-radius: 4px;
        margin-left: 8px;
    }

    #head .btn-register {
        height: 33px;
        line-height: 33px;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        background-color: #eb9316;
        padding: 0 12px;
        border-radius: 4px;
        margin-left: 8px;
    }

    #head button.login:active,
    #head .register:active {
        opacity: 0.7;
    }
}
/* 学会网站声明 start */
.declaration-modal .ant-modal-content {
     background: url(../assets/imgs/bg_declaration.png) no-repeat;
     background-size: 100% 100%;
}

.declaration-modal .ant-modal-content .ant-modal-body {
    padding: 60px 53px 0px 53px;
}

.declaration-modal .declaration-content {
    user-select: none;
    min-height: 54vh;
    display: flex; 
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: transparent;
    position: relative;
}

.declaration-modal .declaration-content .logo-declaration {
    position: absolute;
    left: 0;
    top: 0;
}

.declaration-modal .declaration-content .logo-declaration > img {
    width: 178px;
    height: 55px;
    object-fit: contain;
}

.declaration-modal .declaration-content .title {
    display: block;
    text-align: center;
    font-size: 36px;
    color: #413527;
    line-height: 77px;
    font-family: "my-kaiti";
}

.declaration-modal .ant-checkbox {
    font-size: 24px;
}

.declaration-modal .declaration-content .desc {
    color: #413527;
    font-size: 20px;
    line-height: 30px;
    margin: 24px 22px 0px 22px;
    font-family: "my-kaiti";
}

.declaration-modal .declaration-content .cb-agree {
    font-size: 24px;
    line-height: 24px;
    color: #413527;
    font-family: "my-kaiti";
    margin-top: 24px;
}

.declaration-modal .declaration-content .btn-agree {
    background-color: #7F6F5C;
    padding: 0px 59px;
    height: 42px;
    line-height: 42px;
    border-radius: 21px;
    color: #fff;
    font-family: "my-kaiti";
    margin-top: 30px;
    cursor: pointer;
    font-size: 24px;
}

.declaration-modal .ant-checkbox-inner {
    background-color: transparent;
    border-color: #413527;
}

.declaration-modal .ant-checkbox-input + .ant-checkbox-inner {
    border-color: #413527;
}

.declaration-modal .ant-checkbox-input:focus + .ant-checkbox-inner {
    background-color: transparent;
}

.declaration-modal .ant-checkbox-checked::after {
    border-color: #413527;
}

.declaration-modal .ant-checkbox-checked .ant-checkbox-inner::after {
    position: absolute;
    display: table;
    border: 2px solid #413527;
    border-top: 0;
    border-left: 0;
    transform: rotate(45deg) scale(1) translate(-50%, -50%);
    opacity: 1;
    transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    content: ' ';
}

@media only screen and (max-width: 800px) {
    .declaration-modal .declaration-content .logo-declaration > img {
        width: 120px;
        height: 48px;
        object-fit: contain;
    }
}

@media only screen and (max-width: 600px) {
    .declaration-modal .declaration-content {
        min-height: 80vh !important;
    }

    .declaration-modal .ant-modal-content .ant-modal-body {
        padding: 30px 24px 0px 24px;
    }
    
    .declaration-modal .declaration-content .logo-declaration {
        position: absolute;
        left: 12px;
        top: 12px;
    }

    .declaration-modal .declaration-content .logo-declaration > img {
        width: 92px;
        height: 45px;
        object-fit: contain;
    }
}
@media only screen and (max-width: 450px) {
    .declaration-modal .declaration-content .logo-declaration > img {
        width: 62px;
        height: 35px;
        object-fit: contain;
    }

    .declaration-modal .declaration-content .logo-declaration {
        position: absolute;
        left: -2px;
        top: 20px;
    }
}
/* 学会网站声明 end */
</style>
